import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../../../auth/auth";
import {
    addOnBoardingFormDocuments,
  DeleteOnBoardingDocument,
  getUserOnBoardingDocument,
} from "../../../../../api/apiCall";
import { Button, Checkbox, Modal, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileWord,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { toast } from "react-toastify";
import styles from "./OnboardingFormDocuments.module.css";

const OnboardingFormDocuments = () => {
  const { state } = useAuth();
  const location = useLocation();
  const [documents, setDocuments] = useState<any>([]);
  const { userOnboardingFormId, name, surname, onboardingFormName } = location.state || {};
  const fileInputRef = useRef<any>(null);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [, setOpen] = useState(false);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const getonboardingFormDocuments = async () => {
    setLoading(true);
    try {
      const response = await getUserOnBoardingDocument(
        state.user?.token,
        userOnboardingFormId
      );
      setDocuments(response?.data);
    } catch (error) {
      console.error("Error fetching documents:", error);
      toast.error("Failed to load documents");
    } finally {
      setLoading(false);
    }
  };

  const generateBlobUrl = (base64Data: any, contentType: any) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    // Convert base64 string to a byte array
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const byteArray = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(byteArray);
  };

  const bytesToMB = (bytes: number) => {
    return (bytes / (1024 * 1024)).toFixed(2);
  };

  const handleImageUpload = async (event: any) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      setUploading(true);

      try {
        const response = await addOnBoardingFormDocuments(state.user?.token, {
          userTicketId: userOnboardingFormId,
          documents: fileArray,
        });
        console.log(response);
        if (response?.data.success) {
          await getonboardingFormDocuments();
          toast.success("Document uploaded successfully");
        }
      } catch (error) {
        console.error("Error uploading files:", error);
        toast.error("Failed to upload document");
      } finally {
        setUploading(false);
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    }
  };

  const handleDelete = async (onboardingFormId: any) => {
    setDeleting(true);
    try {
      const response = await DeleteOnBoardingDocument(
        state.user?.token,
        onboardingFormId
      );
      if (response?.status === 200) {
        await getonboardingFormDocuments();
        toast.error("Document deleted successfully");
        setSelectedDocument(null);
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document");
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    getonboardingFormDocuments();
  }, []);

  const onChange = (e: any, document: any) => {
    if (e.target.checked) {
      setSelectedDocument(document);
    } else {
      setSelectedDocument(null);
    }
  };

  return (
    <>
      <header className={styles.headerLogger}>
        <h2>
          {onboardingFormName} Documents
          <h4 className={styles.ukTime}>
            {name} {surname}{" "}
          </h4>
        </h2>
        <div>
          {selectedDocument && (
            <Button
              danger
              type="primary"
              onClick={() => {
                setOpen(true);
                Modal.confirm({
                  title: `Are you sure you want to delete ${selectedDocument.documentName}?`,
                  onOk: () => handleDelete(selectedDocument.id),
                  okButtonProps: { danger: true, loading: deleting },
                  okText: "YES",
                  cancelText: "NO",
                  centered: true,
                });
              }}
              disabled={deleting}
            >
              Delete
            </Button>
          )}
          <Button
            type="primary"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={handleButtonClick}
            style={{ margin: 20 }}
            loading={uploading}
            disabled={uploading}
          >
            Add New
          </Button>
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.gif,.bmp,.tiff,.xls,.xlsx,.doc,.docx,.pdf"
            hidden
            multiple
            ref={fileInputRef}
            onChange={handleImageUpload}
            disabled={uploading}
          />
        </div>
      </header>

      <Spin spinning={loading} tip="Loading documents...">
        {documents.length > 0 ? (
          <table className={styles.ticketLoggerTable}>
            <thead>
              <tr>
                <th className={styles.left}></th>
                <th className={styles.left}>Type</th>
                <th>Name</th>
                <th>Added Date</th>
                <th>File Size</th>
               </tr>
            </thead>
            <tbody>
              {documents.map((doc: any) => (
                <tr key={doc.id}>
                  <td>
                    <Checkbox
                      onChange={(e) => onChange(e, doc)}
                      checked={selectedDocument?.id === doc.id}
                      disabled={uploading || deleting}
                    />
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <div>
                      {doc.contentType === "image/png" ||
                      doc.contentType === "image/jpeg" ? (
                        <FontAwesomeIcon
                          icon={faFileImage}
                          size="2x"
                          color="gray"
                        />
                      ) : doc.contentType ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                        <FontAwesomeIcon
                          icon={faFileExcel}
                          color="#107c41"
                          size="2x"
                        />
                      ) : doc.contentType ===
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                        <FontAwesomeIcon
                          icon={faFileWord}
                          color="#185abd"
                          size="2xl"
                        />
                      ) : doc.contentType === "application/pdf" ? (
                        <FontAwesomeIcon
                          icon={faFilePdf}
                          color="#e84133"
                          size="2xl"
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faFileImage}
                          size="2x"
                          color="gray"
                        />
                      )}
                    </div>
                  </td>
                  <td>
                    <a
                      href={generateBlobUrl(doc.data, doc.contentType)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      {doc.documentName}
                    </a>
                  </td>
                  <td>{format(new Date(doc.createdDate), "MMMM d, yyyy")}</td>
                  <td>{bytesToMB(doc.size)} MB</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          !loading && (
            <div className={styles.noDocument}>
              No documents available for this Onboarding Form.
            </div>
          )
        )}
      </Spin>
    </>
  );
};

export default OnboardingFormDocuments;
